<template>
  <div class="achievement">
    <CommonLayout>
      <div slot="header">
        <h3>科技成果</h3>
      </div>
      <div slot="container">
        <div class="achievement-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addAch"
            style="background: #623aa2; border: none"
          >
            新增
          </el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
          <!-- <el-popconfirm
            title="这是一段内容确定删除吗？"
          >
          <el-button
            type="primary"
            class="exportOut"
            icon="el-icon-download"
            slot="reference"
          >导出</el-button>
          </el-popconfirm>-->
          <!-- <el-popover placement="bottom" width="300" v-model="visible">
            <el-date-picker
              style="width: 100%"
              v-model="times"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <div style="text-align: right; margin-top: 10px">
              <el-button
                size="mini"
                type="text"
                @click="
                  () => {
                    visible = false;
                    times = null;
                  }
                "
              >
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="exportOut">确定</el-button>
            </div>
            <el-button
              class="exportOut"
              style="margin-left: 10px"
              slot="reference"
              type="primary"
              icon="el-icon-download"
            >
              导出
            </el-button>
          </el-popover> -->
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <label>所属领域:</label>
          <el-select
            style="width: 140px"
            v-model="fieldValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in checkList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <label>应用行业:</label>
          <el-select
            style="width: 140px"
            v-model="tradeValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <label>成果来源:</label>
          <el-cascader
            style="width:140px"
            placeholder="请选择"
            v-model="naturalValue"
            @change="search"
            :props="{ checkStrictly: true }"
            :options="options.source"
            clearable
          ></el-cascader>-->
          <!-- <el-select style="width:140px" v-model="naturalValue" clearable placeholder="全部" @change='search'>
            <el-option
              v-for="item in options.source"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>-->
          <!-- <label>技术类型:</label>
          <el-select
            style="width:140px"
            v-model="typeValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in options.type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>-->
          <label>合作方式:</label>
          <el-select
            style="width: 140px"
            v-model="wayValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in options.cooperation"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>发布平台:</label>
          <el-select
            style="width: 140px"
            v-model="srelease"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in options.sourcerelease"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>审核状态:</label>
          <el-select
            style="width: 140px"
            v-model="isShow"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in options.isShow"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>标签:</label>
          <el-select
            style="width: 140px"
            v-model="label"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in options.label"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
          <label>城市:</label>
          <el-select v-model="area_name" placeholder="请选择区域" @change="search" clearable>
            <el-option
              v-for="item in areaList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-button type="success" @click="listingAch" style="background: #088f08; border: none">
            批量挂牌
          </el-button>
          <el-button type="primary" @click="downFn">下载Excel模板</el-button>

          <el-button type="success" @click="exportFn">导入Excel</el-button>
          <!-- <el-button type="primary" @click="exportCondition">条件导出</el-button> -->

          <el-popover placement="bottom" width="300" v-model="yearvisible">
            <el-date-picker
              style="width: 100%"
              v-model="yearValue"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <div style="text-align: right; margin-top: 10px">
              <el-button
                size="mini"
                type="text"
                @click="
                  () => {
                    yearvisible = false;
                    yearValue = null;
                  }
                "
              >
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="exportCondition">确定</el-button>
            </div>
            <el-button
              class="exportOut"
              style="margin-left: 10px"
              slot="reference"
              type="primary"
              icon="el-icon-download"
            >
              导出
            </el-button>
          </el-popover>

          <!-- <label>成果发布来源:</label>
          <el-select
            style="width: 140px"
            v-model="sreleases"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in options.sourcereleases"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
        </div>

        <div class="achievement-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="成果名称" align="center"></el-table-column>
            <el-table-column label="成果简介" align="center">
              <template slot-scope="scope">
                <span style="display: block; height: 23px; overflow: hidden">
                  {{ GetTarg(scope.row.introduction) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="label" label="标签" align="center"></el-table-column>
            <!-- <el-table-column prop="type" label="技术类型" align="center"></el-table-column>
            <el-table-column prop="maturity" label="成熟度" align="center"></el-table-column>-->
            <el-table-column
              prop="createDatetime"
              label="申请时间"
              align="center"
            ></el-table-column>
            <el-table-column label="成果发布来源" align="center">
              <template slot-scope="scope">
                {{ scope.row.status === 1 ? "后台新增" : "前台新增" }}
              </template>
            </el-table-column>
            <el-table-column prop="isShow" label="审核状态" align="center">
              <template slot-scope="scope">
                <el-tag type="success" v-show="scope.row.isShow == 1">通过</el-tag>
                <el-tag type="info" v-show="scope.row.isShow == 2">未通过</el-tag>
                <el-tag type="danger" v-show="scope.row.isShow == 3">待审核</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement === 1 && scope.row.isMarket === 1
                    ? "双平台"
                    : scope.row.isMarket === 1
                    ? "大市场平台"
                    : "成果交易平台"
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="240">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.is_show !== 1"
                >通过审核</el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消审核</el-button>-->
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </CommonLayout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="form" ref="form" :rules="rules" label-width="100px" class="demo-ruleForm">
        <div class="form-title">基本信息</div>

        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="成果名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入成果名称" clearable></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="标签" prop="label">
                <el-select
                  style="width: 100%"
                  v-model="form.label"
                  clearable
                  placeholder="请输入成果标签"
                >
                  <el-option
                    v-for="item in options.label"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
                <!-- <el-input v-model="form.label" placeholder="请输入成果标签" clearable></el-input> -->
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="所属领域" prop="field">
                <el-select
                  multiple
                  v-model="form.field"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in checkList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="应用行业" prop="trade">
                <el-select multiple style="width: 100%" v-model="form.trade" placeholder="请选择">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="成熟度" prop="mastery">
                <el-select
                  multiple
                  v-model="form.mastery"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in options.stage"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="合作方式" prop="way">
                <el-select
                  multiple
                  v-model="form.way"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in options.cooperation"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="行业分类" prop="level_id">
                <el-cascader
                  v-model="form.level_id"
                  placeholder="请选择"
                  :options="sortOptions"
                  style="width: 100%"
                  clearable
                  :props="{ value: 'id', label: 'name', checkStrictly: true }"
                ></el-cascader>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item style="text-align: right" label="封面图片" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img
                  v-if="form.logo"
                  :src="imgUrl + form.logo"
                  class="img_border"
                  v-real-img="form.logo"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !form.logo }"
                ></i>
                <span class="upload_btn" v-if="!form.logo">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="form.logo">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="技术先进度" prop="advanced">
              <el-select
                multiple
                v-model="form.advanced"
                placeholder="请选择"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in options.stage1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间" prop="pubdate">
              <el-date-picker
                style="width: 100%"
                :picker-options="pickerOptions"
                v-model="form.pubdate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-title">项目来源</div>
        <!-- <el-row>
          <el-form-item label="单位名称" prop="unit">
            <el-input v-model="form.unit" placeholder="请输入单位名称" clearable></el-input>
          </el-form-item>
        </el-row>-->
        <el-row>
          <el-col :span="12">
            <el-form-item label="个人/单位">
              <el-select style="width: 100%" v-model="form.isPerson">
                <el-option :value="1" label="个人"></el-option>
                <el-option :value="2" label="单位"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="people">
              <el-input v-model="form.people" placeholder="请输入联系人" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入联系电话" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="通信地址" prop="detailed">
            <v-distpicker
              style="text-align: left"
              @selected="citySelected"
              :province="form.address.province.value"
              :city="form.address.city.value"
              :area="form.address.area.value"
            ></v-distpicker>
            <el-input
              style="margin-top: 10px"
              v-model="form.detailed"
              placeholder="请填写详细地址"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row v-if="form.isPerson == 2">
          <el-col :span="12">
            <el-form-item label="单位名称" prop="unit">
              <el-input v-model="form.unit" placeholder="请输入单位名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位性质" prop="unitProperties">
              <!-- <el-cascader
	            placeholder="请选择"
	            style="width:100%"
	            v-model="form.naturalJson"
	            :options="options.source"
	            :props="{ multiple: true }"
	            clearable
              ></el-cascader>-->
              <el-select
                v-model="form.unitProperties"
                placeholder="请选择"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in options.source1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成果来源" prop="naturalJson" v-if="form.isPerson == 2">
              <el-cascader
                placeholder="请选择"
                style="width: 100%"
                v-model="form.naturalJson"
                :options="options.source"
                :props="{ value: 'id', label: 'name', children: 'children' }"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="技术类型" prop="type">
              <el-select
                multiple
                v-model="form.type"
                placeholder="请选择"
                style="width:100%"
                clearable
              >
                <el-option
                  v-for="item in options.type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
        </el-row>
        <div class="form-title">项目简介</div>
        <el-row>
          <el-form-item label="成果简介" prop="introduction">
            <editor
              v-model="form.introduction"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
            <!-- <editor
              :quill-data="form.introduction"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
              @getQuillData="getQuillData"
            ></editor>-->
          </el-form-item>
          <el-col :span="24" class="flex-end">
            <el-button @click="getTopKey" size="mini" type="primary">
              点击获取关键词(新版)
            </el-button>
            <!-- <el-button @click="getTopKeyNew" size="mini" type="primary">
              点击获取关键词(新版)
            </el-button> -->
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <el-form-item label="审核人" prop="checkerId" style="text-align: left">
              <el-select
                v-model="form.checkerId"
                placeholder="请选择"
                style="width: 100%"
                @change="changeCheck()"
              >
                <el-option
                  v-for="(item, index) in checkerOption"
                  :key="index"
                  :label="item.username"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关键字(新版)" prop="keyName">
              <el-select
                style="width: 100%"
                v-model="form.keyName"
                multiple
                filterable
                @change="changeKeyName"
                allow-create
                default-first-option
                placeholder="请选择文章标签"
              >
                <el-option
                  v-for="item in Resource_Keys"
                  :key="item.id"
                  :label="item.key"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="关键字(新版)" prop="key_new_name">
              <el-select
                style="width: 100%"
                @change="changeKeyNameNew"
                v-model="form.key_new_name"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="请选择文章标签"
              >
                <el-option
                  v-for="item in Resource_Keys"
                  multiple
                  :key="item.id"
                  :label="item.key"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item> -->
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <el-form-item label="审核状态" prop="isShow" style="text-align: left">
              <el-select
                v-model="form.isShow"
                placeholder="请选择"
                style="width: 100%"
                :disabled="!isCheck || !isChecker"
              >
                <el-option
                  v-for="item in showOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="同步发布" prop="is_market" style="text-align: left">
              <el-select
                v-model="is_market"
                placeholder="请选择"
                style="width: 100%"
                @change="formmarket"
              >
                <el-option label="双平台" :value="1" />
                <el-option label="大市场平台" :value="2" />
                <el-option label="成果交易平台" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="form.isShow === 2">
          <el-form-item label="驳回原因">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              style="margin-top: 10px"
              v-model="form.rejectReason"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-button type="primary" @click="submitForm('form')">提交</el-button>
            <el-button @click="closeForm('form')">取消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
      title="批量挂牌"
      :visible.sync="listingVisible"
      :close-on-click-modal="false"
      width="60%"
      @closed="is_submit = true"
    >
      <el-form
        :model="listForm"
        ref="listForm"
        :rules="listRules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-table :data="listForm.listingData" style="width: 100%">
          <el-table-column prop="achievementName" label="成果名称" align="center">
            <template slot="header" slot-scope="scope">
              成果名称
              <span class="xing">*</span>
            </template>
          </el-table-column>
          <el-table-column prop="listingPrice" label="挂牌价格(元)" align="center">
            <template slot="header" slot-scope="scope">
              挂牌价格(元)
              <span class="xing">*</span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'listingData.' + scope.$index + '.listingPrice'"
                :rules="[{ required: true, message: '挂牌价格', trigger: 'blur' }]"
              >
                <el-input
                  type="number"
                  v-model="listForm.listingData[scope.$index].listingPrice"
                  placeholder="挂牌价格(元)"
                  clearable
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="applicant" align="center">
            <template slot="header" slot-scope="scope">
              申请人
              <span class="xing">*</span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'listingData.' + scope.$index + '.applicantId'"
                :rules="[{ required: true, message: '申请人', trigger: 'blur' }]"
              >
                <el-select
                  v-model="listForm.listingData[scope.$index].applicantId"
                  placeholder="申请人"
                  filterable
                  clearable
                  style="width: 100%;"
                  @change="userChange($event, scope)"
                >
                  <el-option
                    :label="item.username"
                    :value="item.id"
                    v-for="(item, index) in userData"
                    :key="index"
                  />
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="contact" label="联系方式" align="center">
            <template slot="header" slot-scope="scope">
              联系方式
              <span class="xing">*</span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'listingData.' + scope.$index + '.contact'"
                :rules="[{ required: true, message: '联系方式', trigger: 'blur' }]"
              >
                <el-input
                  type="number"
                  v-model="listForm.listingData[scope.$index].contact"
                  placeholder="联系方式"
                  clearable
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="evaluationPrice" label="评估价格(元)" align="center">
            <template slot="header" slot-scope="scope">
              评估价格(元)
              <span class="xing">*</span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'listingData.' + scope.$index + '.evaluationPrice'"
                :rules="[{ required: true, message: '评估价格', trigger: 'blur' }]"
              >
                <el-input
                  type="number"
                  v-model="listForm.listingData[scope.$index].evaluationPrice"
                  placeholder="评估价格"
                  clearable
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="审核状态" align="center">
            <template slot="header" slot-scope="scope">
              审核状态
              <span class="xing">*</span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'listingData.' + scope.$index + '.approvalStatus'"
                :rules="[{ required: true, message: '请选择审核状态', trigger: 'blur' }]"
              >
                <el-select
                  v-model="listForm.listingData[scope.$index].approvalStatus"
                  placeholder="请选择审核状态"
                  clearable
                  style="width: 100%;"
                >
                  <el-option label="待审核" :value="1" />
                  <el-option label="驳回" :value="2" />
                  <el-option label="通过" :value="4" />
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="comments" label="审核意见" align="center">
            <template slot-scope="scope">
              <el-form-item>
                <el-input
                  v-model="listForm.listingData[scope.$index].approvalComments"
                  placeholder="审核意见"
                  clearable
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-button type="primary" @click="submitForm('listForm')">提交</el-button>
            <el-button @click="listingVisible = false">取消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../components/common-layout.vue";
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
import {DisabledDateFn} from "../../utils/tool";
import {getToken} from "../../utils/auth";
import download from '@/utils/download'
import _ from 'lodash-es'
import {FunDownload, ExportFn} from "../../utils/tool";
// import { FunDownload, ExportFn } from ".././../utils/tool";
export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      isCheck: false,
      isChecker: false,
      listingVisible: false,
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      times: "",
      yearValue: "",
      yearvisible: false,
      keepPageNumber: 1,
      is_submit: true,
      visible: false,
      value: "",
      fieldValue: "",
      tradeValue: "",
      naturalValue: "",
      typeValue: "",
      wayValue: "",
      isShow: '',
      label: '',
      srelease: '',
      sreleases: "",
      deleteRow: "",
      total: 10,
      per_page: 10,
      current_page: 1,
      checkAll: false,
      isIndeterminate: false,
      image: "",
      searchValue: "",
      dialogFormVisible: false,
      Title: "新增",
      tableData: [],
      Resource_Keys: [],
      is_market: 1,
      listForm: {
        listingData: []
      },
      listRules: {},
      form: {
        rejectReason: '', // 驳回原因
        name: "",
        label: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        trade: [],
        field: [],
        natural: "",
        natural_second: "",
        natural_third: "",
        unit: "",
        unitProperties: "",
        isPerson: 1,
        // type: [],
        way: [],
        mastery: [],
        advanced: [],
        userData: [],
        pubdate: "",
        people: "",
        phone: "",
        introduction: "",
        isShow: 2,
        is_market: 1,
        is_achievement: 1,
        status: 1,
        naturalJson: [],
        keyName: "",
        key_new_name: "",
        level_id: [],
        checkerId: "",
      },
      showOptions: [
        {
          value: 3,
          label: "待审核",
        },
        {
          value: 1,
          label: "通过",
        },
        {
          value: 2,
          label: "未通过",
        },
      ],
      areaList: [
        {
          name: '兰州市',
          id: '001',
        },
        {
          name: '嘉峪关市',
          id: '002',
        },
        {
          name: '金昌市',
          id: '003',
        },
        {
          name: '白银市',
          id: '004',
        },
        {
          name: '天水市',
          id: '005',
        },
        {
          name: '武威市',
          id: '006',
        },
        {
          name: '张掖市',
          id: '007',
        },
        {
          name: '酒泉市',
          id: '008',
        },
        {
          name: '平凉市',
          id: '009',
        },
        {
          name: '庆阳市',
          id: '010',
        },
        {
          name: '定西市',
          id: '011',
        },
        {
          name: '陇南市',
          id: '012',
        },
        {
          name: '临夏回族自治州',
          id: '013',
        },
        {
          name: '甘南藏族自治州',
          id: '014',
        }
      ],
      area_name: '',
      // 从{{data}}数据中以项目名称模糊匹配出{{dtls}}中的项目，返回正确的项目的名称和id。
      options: {
        isShow: [
          {value: 1, label: '审核通过'},
          {value: 2, label: '未通过'},
          {value: 3, label: '待审核'},
        ],
        label: [
          {label: '煤炭开采和洗选业'},
          {label: '医药制造业'},
          {label: '农副食品加工业'},
          {label: '计算机、通信和其他电子设备制造业'},
          {label: '化学原料和化学制品制造业'},
          {label: '非金属矿物制品业'},
          {label: '通用设备制造业'},
          {label: '电气机械和器材制造业'},
          {label: '专用设备制造业'},
          {label: '化学纤维制造业'},
          {label: '其他制造业'},
          {label: '食品制造业'},
          {label: '汽车制造业'},
          {label: '仪器仪表制造业'},
          {label: '铁路、船舶、航空航天和其他运输设备制造业'},
          {label: '木材加工和木、竹、藤、棕、草制品业'},
          {label: '废弃资源综合利用业'},
          {label: '水的生产和供应业'},
          {label: '金属制品业'},
          {label: '电力、热力生产和供应业'},
          {label: '纺织业'},
          {label: '开采专业及辅助性活动'},
          {label: '纺织服装、服饰业'},
          {label: '石油、煤炭及其他燃料加工业'},
          {label: '有色金属冶炼和压延加工业'},
          {label: '酒、饮料和精制茶制造业'},
          {label: '黑色金属冶炼和压延加工业'},
          {label: '金属制品、机械和设备修理业'},
          {label: '家具制造业'},
          {label: '非金属矿采选业'},
          {label: '文教、工美、体育和娱乐用品制造业'},
          {label: '橡胶和塑料制品业'},
          {label: '有色金属矿采选业'},
          {label: '造纸和纸制品业'},
          {label: '石油和天然气开采业'},
          {label: '印刷和记录媒介复制业'},
          {label: '皮革、毛皮、羽毛及其制品和制鞋业'},
          {label: '烟草制品业'},
          {label: '其他采矿业'},
          {label: '黑色金属矿采选业'},
          {label: '燃气生产和供应业'},
        ],
        sourcerelease: [
          {
            value: 1,
            label: '双平台'
          },
          {
            value: 2,
            label: '大市场平台'
          },
          {
            value: 3,
            label: '成果交易平台'
          }
        ],
        sourcereleases: [
          {
            value: 1,
            label: '后台新增'
          }, {
            value: 2,
            label: '前台新增'
          }
        ],
        stage: [
          {
            value: "001",
            label: "正在研发",
          },
          {
            value: "002",
            label: "已有样品",
          },
          {
            value: "003",
            label: "小试阶段",
          },
          {
            value: "004",
            label: "中试阶段",
          },
          {
            value: "005",
            label: "可以量产",
          },
        ],
        stage1: [
          {
            value: "001",
            label: "国际领先",
          },
          {
            value: "002",
            label: "国际先进",
          },
          {
            value: "003",
            label: "国内领先",
          },
          {
            value: "004",
            label: "国内先进",
          },
          // {
          //   value: "005",
          //   label: "国内一般"
          // }
        ],
        source1: [
          {
            value: "001",
            label: "民营企业",
          },
          {
            value: "002",
            label: "国有企业",
          },
          {
            value: "003",
            label: "其他",
          },
        ],
        source: [
          // {
          //   value: "001",
          //   label: "技术转移中心",
          //   children: [
          //     {
          //       value: "0011",
          //       label: "张江兰白创新改革试验区技术转移中心"
          //     },
          //     {
          //       value: "0012",
          //       label: "北京大学技术转移甘肃中心"
          //     },
          //     {
          //       value: "0013",
          //       label: "中国科学技术大学技术转移甘肃中心"
          //     },
          //     {
          //       value: "0014",
          //       label: "国家技术转移东部中心"
          //     },
          //     {
          //       value: "0015",
          //       label: "瑞士洛桑大学技术转移中心"
          //     },
          //     {
          //       value: "0016",
          //       label: "新加坡南洋理工大学技术转移中心"
          //     }
          //   ]
          // },
          // {
          //   value: "002",
          //   label: "一院三所",
          //   children: [
          //     {
          //       value: "0021",
          //       label: "中国科学院兰州化学物理研究所"
          //     },
          //     {
          //       value: "0022",
          //       label: "中国科学院近代物理研究所"
          //     },
          //     {
          //       value: "0023",
          //       label: "中国科学院寒区旱区环境与工程研究所"
          //     }
          //   ]
          // },
          // {
          //   value: "003",
          //   label: "在甘院校",
          //   children: [
          //     {
          //       value: "0031",
          //       label: "高等院校",
          //       children: [
          //         {
          //           value: "00311",
          //           label: "兰州大学"
          //         },
          //         {
          //           value: "00312",
          //           label: "兰州理工大学"
          //         },
          //         {
          //           value: "00313",
          //           label: "兰州交通大学"
          //         },
          //         {
          //           value: "00314",
          //           label: "西北民族大学"
          //         },
          //         {
          //           value: "00315",
          //           label: "甘肃农业大学"
          //         },
          //         {
          //           value: "00316",
          //           label: "兰州城市学院"
          //         },
          //         {
          //           value: "00317",
          //           label: "西北师范大学"
          //         },
          //         {
          //           value: "00318",
          //           label: "河西学院"
          //         },
          //         {
          //           value: "00319",
          //           label: "陇东学院"
          //         }
          //       ]
          //     },
          //     {
          //       value: "0032",
          //       label: "科研院所",
          //       children: [
          //         {
          //           value: "00321",
          //           label: "甘肃省科学院"
          //         },
          //         {
          //           value: "00322",
          //           label: "甘肃省农业科学院"
          //         },
          //         {
          //           value: "00323",
          //           label: "甘肃省膜科学技术研究院有限公司"
          //         },
          //         {
          //           value: "00324",
          //           label: "甘肃省科学院生物研究所"
          //         },
          //         {
          //           value: "00325",
          //           label: "甘肃省商业科技研究所"
          //         },
          //         {
          //           value: "00326",
          //           label: "甘肃省建材科研设计院"
          //         }
          //       ]
          //     }
          //   ]
          // },
          // {
          //   value: "004",
          //   label: "省属企业"
          // },
          // {
          //   value: "005",
          //   label: "省外合作机构"
          // },
          // {
          //   value: "006",
          //   label: "新型研发机构",
          //   children: [
          //     {
          //       value: "0061",
          //       label: "兰州大学白银产业技术研究院"
          //     },
          //     {
          //       value: "0062",
          //       label: "兰州理工大学白银新材料研究院"
          //     },
          //     {
          //       value: "0063",
          //       label: "甘肃西部凹凸棒石应用研究院"
          //     },
          //     {
          //       value: "0064",
          //       label: "白银市东西部协同创新研究院"
          //     },
          //     {
          //       value: "0065",
          //       label: "甘肃省陇杞中药研究院"
          //     },
          //     {
          //       value: "0066",
          //       label: "白银市实创高新产业研究院"
          //     }
          //   ]
          // },
          // {
          //   value: "007",
          //   label: "其他"
          // }
        ],
        type: [
          {
            value: "001",
            label: "技术开发",
          },
          {
            value: "002",
            label: "技术转让",
          },
          {
            value: "003",
            label: "技术咨询",
          },
          {
            value: "004",
            label: "技术服务",
          },
        ],
        cooperation: [
          {
            value: "001",
            label: "委托开发",
          },
          {
            value: "002",
            label: "许可转让",
          },
          // {
          //   value: "003",
          //   label: "完全转让",
          // },
          {
            value: "008",
            label: "非专利转让",
          },
          {
            value: "009",
            label: "专利权转让",
          },
          {
            value: "010",
            label: "专利申请权转让",
          },
          {
            value: "011",
            label: "专利实施许可转让",
          },
          {
            value: "004",
            label: "技术入股",
          },
          {
            value: "005",
            label: "技术许可",
          },
          {
            value: "006",
            label: "合作转化",
          },
          // {
          //   value: "007",
          //   label: "自我转化"
          // },
          {
            value: "007",
            label: "其他",
          },
        ],
      },
      checkList: [
        {
          id: "001",
          name: "新能源",
        },
        // {
        //   id: "002",
        //   name: "清洁生产",
        // },
        // {
        //   id: "003",
        //   name: "清洁能源",
        // },
        {
          id: "004",
          name: "现代农业",
        },
        {
          id: "005",
          name: "生物医药",
        },
        {
          id: "006",
          name: "文化旅游",
        },
        {
          id: "007",
          name: "通道物流",
        },
        {
          id: "008",
          name: "军民融合",
        },
        {
          id: "009",
          name: "数据信息",
        },
        {
          id: "010",
          name: "装备制造",
        },
        {
          id: '011',
          name: '新材料',
        },
        {
          id: '012',
          name: '其他',
        },
      ],
      typeOptions: [
        {
          value: "001",
          label: "农业与化工",
        },
        {
          value: "002",
          label: "生物与医药",
        },
        {
          value: "003",
          label: "能源与采矿",
        },
        {
          value: "004",
          label: "建筑与水利",
        },
        {
          value: "005",
          label: "交通与运输",
        },
        {
          value: "006",
          label: "自然与社科",
        },
      ],
      sortOptions: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入成果名称",
            trigger: "blur",
          },
        ],
        detailed: [
          {
            validator: (rule, value, callback) =>
                this.CheckAddress(rule, value, callback, this.form),
            required: true,
            trigger: "blur",
          },
        ],
        // logo: [
        //   {
        //     required: true,
        //     message: "请上传logo",
        //     trigger: "blur",
        //   },
        // ],
        // trade: [
        //   { required: true, message: "请选择应用行业", trigger: "change" }
        // ],
        field: [
          {
            required: true,
            message: "请选择所属领域",
            trigger: "change",
          },
        ],
        naturalJson: [
          {
            required: true,
            message: "请选择成果来源",
            trigger: "change",
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
        // type: [
        //   { required: true, message: "请选择技术类型", trigger: "change" }
        // ],
        // way: [{ required: true, message: "请选择合作方式", trigger: "change" }],
        // mastery: [
        //   { required: true, message: "请选择技术成熟度", trigger: "change" }
        // ],
        // advanced: [
        //   { required: true, message: "请选择技术先进度", trigger: "change" }
        // ],
        pubdate: [
          {
            required: true,
            message: "请选择发布时间",
            trigger: "change",
          },
        ],
        people: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur",
          },
        ],
        introduction: [
          {
            required: true,
            message: "请输入科技成果简介",
            trigger: "blur",
          },
        ],
        keyName: [
          {
            required: true,
            message: "请选择关键字",
            trigger: "change",
          },
        ],
      },
      sourceLists: [],
      checkerOption: [],
      role_id: 0,
    };
  },
  created() {
    this.getChecks();
    this.getTrees();
    const userInfo = JSON.parse(this.$store.getters.userInfo);
    this.role_id = userInfo.role_id;
    this.getData();
    this.getKey();
    this.getTree();
    this.getuser()
  },
  computed: {
    isHongguUser() {
      try {
        const userInfo = JSON.parse(this.$store.getters.userInfo || "{}");
        return userInfo.username === "hongguqu" || userInfo.userName === "hongguqu";
      } catch (e) {
        return false;
      }
    }
  },
  methods: {
    applyHongguQuery(params) {
      if (this.isHongguUser) {
        params.area = "001";
        params.areaName = "兰州市";
        params.districtArea = "620111";
        params.districtAreaName = "红古区";
      }
      return params;
    },
    applyHongguPayload(obj) {
      if (!this.isHongguUser) {
        return obj;
      }
      obj.area = "001";
      obj.areaName = "兰州市";
      obj.districtArea = "620111";
      obj.districtAreaName = "红古区";
      obj.address = this.normalizeAddress(obj.address);
      obj.address.province = { value: "甘肃省" };
      obj.address.city = { value: "兰州市" };
      obj.address.area = { value: "红古区" };
      return obj;
    },
    isHongguRow(row) {
      if (!this.isHongguUser) {
        return true;
      }
      const addressText = JSON.stringify(row.address || "");
      return row.districtAreaName === "红古区" || row.districtArea === "620111" || addressText.indexOf("红古区") > -1;
    },
    normalizeAddress(address) {
      const emptyAddress = {
        province: {
          value: "",
        },
        city: {
          value: "",
        },
        area: {
          value: "",
        },
        detailed: "",
      };
      return {
        ...emptyAddress,
        ...(address || {}),
        province: address && address.province ? address.province : emptyAddress.province,
        city: address && address.city ? address.city : emptyAddress.city,
        area: address && address.area ? address.area : emptyAddress.area,
      };
    },
    getuser() {
      // this.http.get('User?type=2&all=1').then((res) => {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/user/page`, {
        type: 2,
        all: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.code == 0) {
          this.userData = res.data.data;
        }
      })
    },
    //审核人
    getChecks() {
      this.http
          // .get("User?type=2&all=1&is_checker=1&checker_module_id=3")
          .post(`${urlConfig.devUrl}apij2/admin-api/system/user/page`, {
            type: 2,
            all: 1,
            pageSize: 1000,
            isChecker: 1,
            checkerModuleId: 3
          })
          .then((res) => {
            if (res.code == 0) {
              this.checkerOption = res.data.data;
            }
          });
    },
    formmarket(val) {
      if (val === 1) {
        this.form.isMarket = 1
        this.form.isAchievement = 1
      } else if (val === 2) {
        this.form.isMarket = 1
        this.form.isAchievement = 2
      } else {
        this.form.isMarket = 2
        this.form.isAchievement = 1
      }
    },
    //城市筛选
    regionChange(value) {

    },
    changeCheck() {
      this.isChecker = this.form.checkerId == getToken() ? true : false;
      this.isCheck = this.form.checkerId ? true : false;
    },
    //行业分类
    getTrees() {
      // this.http.get("/trade/tree").then((res) => {
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/dic-trade/Recursion`).then((res) => {
        if (res.code == 0) {
          this.sortOptions = res.data;
        }
      });
    },
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    // 监听关键词变更
    changeKeyName(val) {
      if (val.length > 5) {
        this.$message.warning("最多5个关键词");
        this.form.keyName = val.slice(0, 5);
      }
    },
    changeKeyNameNew(val) {
      if (val.length > 5) {
        this.$message.warning("最多5个关键词");
        this.form.key_new_name = val.slice(0, 5);
      }
    },
    // 获取关键词
    async getTopKey() {
      let str = this.GetTarg(this.form.introduction);
      let data = await this.http.post("/top5/key", {content: str});
      this.form.keyName = data.data.map((el) => el.key);
    },
    async getTopKeyNew() {
      let str = this.GetTarg(this.form.introduction);
      let data = await this.http.post("/top5/newkey", {content: str});
      const results = [...data.results];
      this.form.key_new_name = results.map((el) => el.word);
    },

    formatName(ids, rootLists, typeId, typeVal) {
      if (!ids) {
        return "";
      }
      let idsArr = ids?.split(",");
      let result = [];
      idsArr.map((item) => {
        let obj = rootLists.filter((el) => el[typeId] == item);
        if (obj && obj.length > 0) {
          result.push(obj[0][typeVal]);
        }
      });
      return result.join(",");
    },
    getTree() {
      // this.http.get("Unit?all_sub=1").then((res) => {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/user-bind-unit/getListAndTree`).then((res) => {
        if (res.code == 0) {
          this.options.source = res.data.tree;
          this.sourceLists = res.data.list;
          if (this.options.source) {
            this.getTreeData(this.options.source);
          }

        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    //   下载
    downFn() {
      FunDownload(
          this.imgUrl + "科技成果导入模板表.xlsx",
          "科技成果.xlsx"
      );
    },
    async exportFn() {
      let res = await ExportFn(`${urlConfig.devUrl}apij2/admin-api/trade/resource-gain/import-excel`);
      if (res.code === 0) {
        this.$message.success("导入成功");
        this.search();
      } else {
        this.$message.error(res.status);
      }
    },
    async exportCondition() {
      this.current_page = 1;
      if (!this.yearValue) {
        return this.$message.error('请选择日期')
      }
      const data = this.applyHongguQuery({
        all: 1,
        name: this.searchValue,
        page: this.current_page,
        field: this.fieldValue,
        trade: this.tradeValue,
        isShow: this.isShow,
        label: this.label,
        startYear: this.yearValue ? this.yearValue[0] : undefined,
        endYear: this.yearValue ? this.yearValue[1] : undefined,
        natural: this.naturalValue[0],
        naturalSecond: this.naturalValue[1],
        naturalThird: this.naturalValue[2],
        // type: this.typeValue,
        way: this.wayValue,
        ...(this.srelease && {
          isMarket: this.srelease === 1 ? 1 : 2,
          isAchievement: this.srelease === 1 ? 1 : this.srelease === 2 ? 2 : 1
        }),
        ...(this.sreleases && {
          status: this.sreleases === 1 ? 1 : 2
        }),
        // status:this.srelease ? ([1].includes(this.srelease) ? 1 : 2) : undefined,
        area: this.role_id === 29 ? '003' : undefined,
        areaName: this.area_name
      })
      // let url = window.urlConfig.url +"apij2/admin-api/trade/resource-gain/export-excel"
      let url = `${urlConfig.devUrl}apij2/admin-api/trade/resource-gain/export-excel`
      console.log('urlurlurl');
      console.log(url);
      try {
        const response = await this.axios.post(url, data, {responseType: 'blob'});
        console.log('Response data type:', response.data.type);
        console.log('Response data size:', response.data.size);
        download.excel(response.data, '科技资源-科技成果.xls');
        this.yearvisible = false;
        this.yearValue = null;
      } catch (error) {
        console.error('Download failed:', error);
      }
      //  this.axios.post(url,data).then((res) => {
      //   console.log(res);
      //   download.excel(res.data, '课程成果.xls')
      // });
      // var a = document.createElement("a");
      // a.href = url;
      // a.download = "";
      // a.click();
    },
    //导出
    exportOut() {
      let url = "";
      if (this.times) {
        url =
            window.urlConfig.url +
            "Resource_Gain_Export?time_type=1&start_datetime=" +
            this.times[0] +
            "&end_datetime=" +
            this.times[1] + "&areaName=" + this.area_name;
      } else {
        url = window.urlConfig.url + "Resource_Gain_Export";
      }
      console.log('urlurlurl');
      console.log(url);
      var a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();
      this.visible = false;
      this.times = null;
    },
    getKey() {
      // this.axios.get("Resource_Key?all=1").then((res) => {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-key/page`, {
        all: 1,
        pageSize: 100
      }).then((res) => {
        if (res.code == 0) {
          this.Resource_Keys = res.data.data.splice(0, 100);
        }
      });
    },
    getData() {
      let data = data = this.applyHongguQuery({
        all: 1,
        name: this.searchValue,
        page: this.current_page,
        field: this.fieldValue,
        trade: this.tradeValue,
        isShow: this.isShow,
        label: this.label,
        startYear: this.yearValue ? this.yearValue[0] : undefined,
        endYear: this.yearValue ? this.yearValue[1] : undefined,
        natural: this.naturalValue[0],
        naturalSecond: this.naturalValue[1],
        naturalThird: this.naturalValue[2],
        // type: this.typeValue,
        way: this.wayValue,
        ...(this.srelease && {
          isMarket: this.srelease === 1 ? 1 : 2,
          isAchievement: this.srelease === 1 ? 1 : this.srelease === 2 ? 2 : 1
        }),
        ...(this.sreleases && {
          status: this.sreleases === 1 ? 1 : 2
        }),
        area: this.role_id === 29 ? '003' : undefined,
        areaName: this.area_name,
      })
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-gain/page`, data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data?.total || 0;
          this.per_page = res.data?.per_page || 10;
          this.current_page = (res.data?.current_page || 1) * 1;
        }
      });
    },
    //新增
    addAch() {
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.is_market = 1
      this.form = {
        name: "",
        label: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        trade: [],
        field: [],
        naturalJson: [],
        natural: "",
        natural_second: "",
        natural_third: "",
        unit: "",
        unitProperties: "",
        isPerson: 1,
        // type: [],
        way: [],
        mastery: [],
        advanced: [],
        pubdate: "",
        people: "",
        phone: "",
        introduction: "",
        isShow: 2,
        isMarket: 1,
        isAchievement: 1,
        status: 1,
        keyName: [],
        level_id: [],
        checkerId: "",
        rejectReason: ''
      };
    },
    //编辑
    handleEdit(index, row) {
      if (!this.isHongguRow(row)) {
        this.$message.warning("红古区分平台只能编辑红古区数据");
        return;
      }
      console.log(row, 'row')
      this.isCheck = row.checkerId ? true : false;
      this.isChecker = row.checkerId == getToken() ? true : false;
      this.dialogFormVisible = true;
      this.Title = "编辑";
      row.address = this.normalizeAddress(row.address);
      row.detailed = row.address.detailed || '';
      this.form = {...this.form, ...row};
      this.form.address = this.normalizeAddress(this.form.address);
      this.is_market = this.form.isAchievement === 1 && this.form.isMarket === 1 ? 1 : (this.form.isMarket === 1 ? 2 : 3)
      this.form.field = row?.field ? row.field.split(",") : row.field;
      this.form.trade = row?.trade ? row.trade.split(",") : row.trade;
      this.form.natural = row?.natural ? row.natural.split(",") : row.natural;
      // this.form.type = row.type && row.type.split(",");
      this.form.way = row?.way ? row.way.split(",") : row.way;
      this.form.mastery = row?.mastery ? row.mastery.split(",") : row.mastery;
      this.form.advanced = row?.advanced
          ? row.advanced.split(",")
          : row.advanced;
      this.form.naturalJson = row?.naturalJson
          ? JSON.parse(this.form.naturalJson)
          : [];
      this.form.isPerson = row.isPerson;
      this.form.unitProperties = row.unitProperties;
      console.log('keyNamekeyNamekeyNamekeyName');
      console.log(row.keyName);

      this.form.keyName = row?.keyName ? row.keyName.split(",") : [];
      console.log(this.form.keyName);
      this.form.key_new_name = row?.key_new_name ? row.key_new_name : [];
      this.form.level_id = [];
      if (row.oneLevelId) {
        this.form.level_id.push(row.oneLevelId);
      }
      if (row.twoLevelId) {
        this.form.level_id.push(row.twoLevelId);
      }
      if (row.threeLevelId) {
        this.form.level_id.push(row.threeLevelId);
      }

      this.form.checkerId = row.checkerId ? row.checkerId : "";
      this.form.rejectReason = row.rejectReason ? row.rejectReason : "";
      this.form.id = row.id ? row.id : "";
      // this.fileList = [];
      // if (row.image) {
      //   let arr = [];
      //   arr = row.image.split(",");
      //   arr.forEach((item, index) => {
      //     this.fileList.push({
      //       name: "download.jpg",
      //       url: this.imgUrl + item,
      //       store_result: item,
      //       uid: new Date().getTime() + index
      //     });
      //   });
      // }
    },
    //翻页
    handleCurrentChange(e) {
      this.keepPageNumber = e
      let url = "Resource_Gain?all=1&name=" +
          this.searchValue +
          "&page=" +
          e +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.tradeValue ? "&trade=" + this.tradeValue : "") +
          (this.naturalValue[2]
              ? "&natural_third=" + this.naturalValue[2]
              : this.naturalValue[1]
                  ? "&natural_second=" + this.naturalValue[1]
                  : this.naturalValue[0]
                      ? "&natural=" + this.naturalValue[0]
                      : "") +
          (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '') +
          // (this.typeValue ? "&type=" + this.typeValue : "") +
          (this.wayValue ? "&way=" + this.wayValue : "");
      if (this.role_id === 29) {
        url += '&area=003';
      }
      this.getData(url);
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //删除
    handleDelete(index, row) {
      if (!this.isHongguRow(row)) {
        this.$message.warning("红古区分平台只能删除红古区数据");
        return;
      }
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.http
                .request(this.urlConfig.devUrl + "apij2/admin-api/trade/resource-gain/batchDelete?ids=" + row.id, {
                  ids: row.id,
                }, "delete")
                // this.http
                //   .request("Resource_Gain/" + row.id, "", "delete")
                .then((res) => {
                  if (res.code == 0) {
                    this.ResetSearch([
                      "searchValue",
                      "fieldValue",
                      "tradeValue",
                      "wayValue",
                      "srelease",
                      "label",
                      "isShow"
                    ]);
                    let url = "Resource_Gain?all=1&page=" + this.current_page;
                    if (this.role_id === 29) {
                      url += '&area=003';
                    }
                    this.getData(url);
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                  } else {
                    this.$message({
                      message: "失败！",
                      type: "error",
                    });
                  }
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    listingAch() {
      if (this.deleteRow) {
        var list = this.deleteRow.split(',').filter(el => {
          return this.tableData.filter(item => item.id === Number(el))[0].isShow === 1
        })
        if (list.length === 0) {
          this.$message({
            type: "warning",
            message: "所选成果不满足挂牌条件（审核通过且未挂牌过的成果才能进行挂牌操作）",
          });
          return
        }
        this.http.post(this.urlConfig.devUrl + 'apij2/admin-api/trade/listing-transaction/verifyListing', {
          ids: list
        }).then(res => {
          console.log(res);
          if (res.data.length === 0) {
            this.$message({
              type: "warning",
              message: "所选成果不满足挂牌条件（审核通过且未挂牌过的成果才能进行挂牌操作）",
            });
            return
          }
          this.listForm.listingData = res.data.map((el, index) => {
            return {
              achievementId: el,
              achievementName: this.tableData.filter(item => item.id === Number(el))[0].name,
              listingPrice: undefined,
              applicantName: undefined,
              applicantId: undefined,
              contact: undefined,
              evaluationPrice: undefined,
              approvalStatus: 1,
              approvalComments: undefined
            }
          })
          this.listingVisible = true
        })
      } else {
        this.$message({
          type: "warning",
          message: "请选择要挂牌的成果",
        });
      }
    },
    userChange(e, row) {
      this.listForm.listingData[row.$index].contact = this.userData.filter(el => el.id === e)[0].phone
      this.listForm.listingData[row.$index].applicantName = this.userData.filter(el => el.id === e)[0].username
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
            .then(() => {
              this.http
                  .request(this.urlConfig.devUrl + "apij2/admin-api/trade/resource-gain/batchDelete?ids=" + this.deleteRow, {
                    ids: this.deleteRow,
                  }, "delete")
                  // this.http
                  //   .request("Resource_Gain/" + this.deleteRow, "", "delete")
                  .then((res) => {
                    if (res.code == 0) {
                      this.ResetSearch([
                        "searchValue",
                        "fieldValue",
                        "tradeValue",
                        "wayValue",
                        "srelease",
                        "label",
                        "isShow"
                      ]);

                      this.current_page = 1;
                      let url = "Resource_Gain?all=1&page=" + this.current_page;
                      if (this.role_id === 29) {
                        url += '&area=003';
                      }
                      this.getData(url);
                      this.$message({
                        type: "success",
                        message: "删除成功",
                      });
                    } else {
                      this.$message({
                        message: "失败！",
                        type: "error",
                      });
                    }
                  });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的事记",
        });
      }
    },
    //获取经纬度
    factory(name) {
      this.form.address = this.normalizeAddress(this.form.address);
      // if(!this.form.detailed) {
      //   this.$message.warning("请填写详细地址")
      //   return
      // }
      this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          this.form.detailed + "&city=" + this.form.address.city.value + "&children=1&offset=20&page=1&extensions=all"
      ).then((json) => {
        let arr = json.pois[0]?.location ? json.pois[0]?.location.split(",") : [];
        this.form.longitude = arr[0];
        this.form.latitude = arr[1];
        this.subData(name);
      }).catch(err => {
        this.$message.error("未获取到经纬度,请查看地址是否完整");
      });
    },
    // 校验省内省外数据

    getCheck() {
      return new Promise((resolve) => {
        this.form.address = this.normalizeAddress(this.form.address);
        this.form.naturalJson;
        if (
            (this.form.address.province.value === "甘肃省" ||
                this.form.address.province.value === "省") &&
            this.form.naturalJson[0] === 5
        ) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },

    async subData(name) {
      let flag = await this.getCheck();
      if (flag) {
        this.$message.warning("请注意通信地址和成果来源不匹配");
        return;
      }

      let obj = Object.assign({}, this.form);
      let arr = [];
      // this.fileList.forEach(item => {
      //   if (item.response) {
      //     arr.push(item.response.data.store_result);
      //   } else {
      //     arr.push(item.store_result);
      //   }
      // });
      // obj.image = arr.join(",");
      obj.isMarket = this.is_market;
      obj.address.detailed = this.form.detailed;
      obj.trade = obj.trade ? obj.trade.join(",") : obj.trade;
      obj.field = obj.field ? obj.field.join(",") : obj.field;
      obj.field_name = this.formatName(obj.field, this.checkList, "id", "name");
      obj.trade_name = this.formatName(
          obj.trade,
          this.typeOptions,
          "value",
          "label"
      );

      // obj.natural = obj.natural.join(",");
      // obj.type = obj.type.join(",");
      obj.way = obj.way ? obj.way.join(",") : obj.way;
      obj.way_name = this.formatName(
          obj.way,
          this.options.cooperation,
          "value",
          "label"
      );
      obj.unitProperties = obj.unitProperties;
      obj.unitProperties_name = this.formatName(
          obj.unitProperties,
          this.options.source1,
          "value",
          "label"
      );
      obj.mastery = obj.mastery ? obj.mastery.join(",") : obj.mastery;
      obj.mastery_name = this.formatName(
          obj.mastery,
          this.options.stage,
          "value",
          "label"
      );
      obj.advanced = obj.advanced ? obj.advanced.join(",") : obj.advanced;
      obj.advanced_name = this.formatName(
          obj.advanced,
          this.options.stage1,
          "value",
          "label"
      );
      obj.date_time = new Date().format("yyyy-MM-dd hh:mm:ss");
      let area = [
        {
          name: "兰州市",
          id: "001",
        },
        {
          name: "嘉峪关市",
          id: "002",
        },
        {
          name: "金昌市",
          id: "003",
        },
        {
          name: "白银市",
          id: "004",
        },
        {
          name: "天水市",
          id: "005",
        },
        {
          name: "武威市",
          id: "006",
        },
        {
          name: "张掖市",
          id: "007",
        },
        {
          name: "酒泉市",
          id: "008",
        },
        {
          name: "平凉市",
          id: "009",
        },
        {
          name: "庆阳市",
          id: "010",
        },
        {
          name: "定西市",
          id: "011",
        },
        {
          name: "陇南市",
          id: "012",
        },
        {
          name: "临夏回族自治州",
          id: "013",
        },
        {
          name: "甘南藏族自治州",
          id: "014",
        },
      ];
      obj.address = this.normalizeAddress(obj.address);
      this.applyHongguPayload(obj);
      area.forEach((item) => {
        if (obj.address.city.value == item.name) {
          obj.area = item.id;
          obj.areaName = item.name;
        }
      });
      let array = [],
          array1 = [],
          array2 = [];
      if (obj.naturalJson.length) {
        // obj.naturalJson.forEach(item => {
        //   array.push(item[0]);
        //   item[1] ? array1.push(item[1]) : "";
        //   item[2] ? array2.push(item[2]) : "";
        // });
        array.push(obj.naturalJson[0]);
        obj.naturalJson[1] ? array1.push(obj.naturalJson[1]) : "";
        obj.naturalJson[2] ? array2.push(obj.naturalJson[2]) : "";
      }
      obj.natural = this.unique(array).join(",");
      obj.natural_name = this.formatName(
          obj.natural,
          this.sourceLists,
          "id",
          "name"
      );
      obj.natural_second = this.unique(array1).join(",");
      obj.natural_second_name = this.formatName(
          obj.natural_second,
          this.sourceLists,
          "id",
          "name"
      );
      obj.natural_third = this.unique(array2).join(",");
      obj.natural_third_name = this.formatName(
          obj.natural_third,
          this.sourceLists,
          "id",
          "name"
      );
      obj.naturalJson = JSON.stringify(obj.naturalJson);

      delete obj.detailed;
      // delete obj.naturalJson;
      obj.keyName = obj.keyName.join(",");

      obj.oneLevelId = obj?.level_id[0] || 0;
      obj.twoLevelId = obj?.level_id[1] || 0;
      obj.threeLevelId = obj?.level_id[2] || 0;
      // let regex = '/font-size:\\s*\\d+px;/g'
      obj.introduction = obj.introduction.replace(/font-size:\s*\d+px;/g, 'font-size: 16px;')
      delete obj.level_id;
      delete (obj.userData);
      delete (obj.key_new_name);

      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      if (!this.form.id) {
        this.http.post(this.urlConfig.devUrl + "apij2/admin-api/trade/resource-gain/create", obj).then((res) => {
          if (res.code == 0) {
            this.ResetSearch([
              "searchValue",
              "fieldValue",
              "tradeValue",
              "wayValue",
              "srelease",
              "label",
              "isShow"
            ]);
            this.is_market = 1
            let url = "Resource_Gain?all=1&page=1";
            if (this.role_id === 29) {
              url += '&area=003';
            }
            this.getData(url);
            this.getKey();
            this.$message({
              type: "success",
              message: "新增成功",
            });

            this.dialogFormVisible = false;
            this.$refs[name].resetFields();
            if (obj.isShow == 1) {
              let obj1 = {
                name: obj.name,
                moudle: "科技成果",
                date_time: obj.date_time,
              };

              this.http.post("Index_Resource", obj1);
            }
          } else {
            this.is_submit = true;
          }
        })
            .catch((err) => {
              this.is_submit = true;
            });
      } else {
        let _id = obj.id
        // delete obj.id;
        // delete obj.date_time;
        console.log(obj, 'obj')
        this.http.post(this.urlConfig.devUrl + "apij2/admin-api/trade/resource-gain/update", obj).then((res) => {
          // this.http.put("Resource_Gain/" + this.form.id, obj).then((res) => {
          if (res.code == 0) {
            // 审核通过，调接口，生成证书信息 上链
            if (obj.isShow === 1) {
              console.log('执行了')
              obj.id = _id
              this.http.post(this.urlConfig.devUrl + 'apij2/admin-api/voucher/achievement-chain/pushToChain', {
                data: obj
              })
            }
            this.ResetSearch([
              "searchValue",
              "fieldValue",
              "tradeValue",
              "wayValue",
              "srelease",
              "label",
              "isShow"
            ]);

            let url = "Resource_Gain?all=1&page=" + this.keepPageNumber;
            if (this.role_id === 29) {
              url += '&area=003';
            }
            this.getData(url);
            this.getKey();
            this.$message({
              type: "success",
              message: "编辑成功",
            });
            this.dialogFormVisible = false;

            this.$refs[name].resetFields();
          } else {
            this.is_submit = true;
          }
        })
            .catch((err) => {
              this.is_submit = true;
            });
      }
    },
    //提交
    submitForm: _.throttle(function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (name === 'listForm') {
            this.http.post(this.urlConfig.devUrl + 'apij2/admin-api/trade/listing-transaction/saveListingList', {
              createReqVOs: this.listForm.listingData
            }).then(res => {
              this.listingVisible = false
              this.$message({
                type: "success",
                message: "挂牌成功",
              });
              this.search();
            })
          } else {
            this.factory(name);
          }
        } else {
          return false;
        }
      });
    }, 3000, {leading: true, trailing: false}),
    //数组去重
    unique(arr) {
      return arr.filter((ele, index, array) => {
        return array.indexOf(ele) === index;
      });
    },
    //关闭
    closeForm(name) {
      this.$refs[name].resetFields();
      this.dialogFormVisible = false;
    },
    //查找
    search() {
      this.current_page = 1;
      const params = this.applyHongguQuery({
        all: 1,
        name: this.searchValue,
        page: this.current_page,
        field: this.fieldValue,
        trade: this.tradeValue,
        isShow: this.isShow,
        label: this.label,
        areaName: this.area_name,
        natural: this.naturalValue[0],
        natural_second: this.naturalValue[1],
        natural_third: this.naturalValue[2],
        way: this.wayValue,
        ...(this.srelease && {
          isMarket: this.srelease === 1 ? 1 : 2,
          isAchievement: this.srelease === 1 ? 1 : this.srelease === 2 ? 2 : 1
        }),
        ...(this.sreleases && {
          status: this.sreleases === 1 ? 1 : 2
        }),
        ...(this.role_id === 29 && {area: '003'})
      });
      // 移除空值参数
      const filteredParams = Object.fromEntries(
          Object.entries(params).filter(([_, value]) => value !== undefined && value !== '')
      );
      this.getData(filteredParams);
    },
    //审核
    release(row, type) {
      row.address = this.normalizeAddress(row.address);
      let obj = {
        is_show: type,
      };
      this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          row.address.detailed +
          "&city=" +
          row.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
          .then((json) => {
            let arr = json.pois[0]?.location.split(",");
            obj.longitude = arr[0];
            obj.latitude = arr[1];
            this.http.put("Resource_Gain/" + row.id, obj).then((res) => {
              if (res.code == 0) {
                if (type == 1) {
                  this.$message.success("审核通过");
                } else {
                  this.$message.success("审核不通过");
                }

                let url = "Resource_Gain?all=1&page=1";
                if (this.role_id === 29) {
                  url += '&area=003';
                }
                this.getData(url);
              }
            });
          })
          .catch((err) => {
            this.$message.error("未获取到经纬度,请查看地址是否完整");
          });
    },
    //富文本
    getQuillData(val) {
      this.form.introduction = val;
    },
    //城市选择
    citySelected(e) {
      console.log("选择数据", e);
      this.form.address = e;
    },
    //关注领域
    // handleCheckAllChange(val) {
    //   this.form.checked = val ? this.checkList : [];
    //   this.isIndeterminate = false;
    // },
    // handleCheckedCitiesChange(value) {
    //   let checkedCount = value.length;
    //   this.checkAll = checkedCount === this.checkList.length;
    //   this.isIndeterminate =
    //     checkedCount > 0 && checkedCount < this.checkList.length;
    // },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
          .then((rst) => {
            this.http
                .post("/file/base64_upload", {
                  image: rst.base64,
                })
                .then((res) => {
                  this.form.logo = res.data;
                });
            return rst;
          })
          .always(() => {
            // 清空文件上传控件的值
            e.target.value = null;
          });
    },

    handlePictureCardPreview(file) {
      this.form.logo = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
          file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/gif" ||
          file.type === "image/bmp"
      ) {
        type = true;
      }

      // var img = new Image();
      // img.src = this.image;
      // img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.form.logo = "";
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
  },
};
</script>

<style scoped lang="scss">
.achievement {
  width: 100%;
  height: 100%;

  .achievement-search {
    width: 100%;
    text-align: left;

    & > * {
      margin-top: 10px;
    }

    // margin-top: 20px;
    .el-select {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-cascader {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-input {
      margin: 0 15px;
    }
  }

  .achievement-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #0572a4;
    border-left: 5px solid #0572a4;
    border-bottom: 1px solid #0572a4;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}

/deep/ .el-table__body .el-form-item__content {
  margin-left: 0 !important;
}

.xing {
  color: #f00;
}
</style>
